import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { MailProcessing } from '../db/MailExtractionResult.js';

export const getMailProcessing = registerQuery({
  type: () => MailProcessing,
  operationName: 'getMailProcessing',
  resolve: (mailID: string) => {
    return async (gqlFields: BaseQLSelectionSet<MailProcessing>) => {
      const rawResultCollection = await getRawCollection<MailProcessing>(MailProcessing._collectionName);
      const result = await rawResultCollection.findOne<MailProcessing>({ mailID });
      return result ?? null;
    };
  },
  params: [{ name: 'mailID', type: () => String }],
});
